import {
    SET_FLEET
} from '../constants/actions';


const initialState = {
    fleet: []
}

const fleetReducer = (state = initialState, action) => {
    if(action.type === SET_FLEET){
        return {...state, fleet: action.fleet}
    }
    else {
        return state;
    }
}

export default fleetReducer;